import {createFileRoute, useParams} from "@tanstack/react-router";

import {routeMessages} from "../../../../../../messages/routes.messages";

import {ExpedientOptionsPage} from "./-page/expedient-options.page";
import {ExpedientOptionsPending} from "./-page/expedient-options.pending";

export const Route = createFileRoute("/_app/sales/expedients/$expedientId/options/")({
  component: RouteComponent,
  pendingComponent: ExpedientOptionsPending,
  staticData: {meta: {labelDescriptor: routeMessages.options}},
});

function RouteComponent() {
  const {expedientId} = useParams({strict: false}) as {expedientId: string};

  return <ExpedientOptionsPage expedientId={expedientId} />;
}
